import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'infoCard',
  standalone: true,
})
export class InfoCardPipe implements PipeTransform {
  transform(obj: { [key: string]: any }) {
    const data = Object.entries(obj).map(([key, value]) => {
      let isTag = false;
      let tagSeverity: 'secondary' | 'success' | 'info' | 'progress' | 'warning' | 'pending' | 'help' | 'danger' | undefined = undefined;
      return {
        name: key,
        value: value,
        type: key == 'dateOfBirth' || key == 'joinedSince' ? 'date' : typeof value,
        isTag,
        tagSeverity,
      };
    });
    return data;
  }
}
